import React from 'react';
import LabelValue from 'components/ui/tailwind/label-value';
import CargomaticCard from 'components/v2/card';
import { sluggify } from 'utils/localization/utils';
import { withTranslation } from 'react-i18next';
import EditButton from '../../v2/buttons/EditButton';
import DeleteButton from '../../v2/buttons/DeleteButton';

const LocationPreview = (props) => {
  const { type, location, t } = props;
  const name = location ? location.name : null;
  const address = location ? location.address : null;

  return (
    <CargomaticCard
      header={() => (
        <div className="flex items-center justify-between">
          <h3 className="my-0 text-xl font-medium">
            {t('DEFAULT_TYPE', { type: t(sluggify(type)) })}
          </h3>
          <div className="flex items-center justify-end -mx-1">
            <div className="px-1">
              <EditButton onClick={() => props.onEdit(type)} />
            </div>
            <div className="px-1">
              <DeleteButton onClick={() => props.onRemove(type)} />
            </div>
          </div>
        </div>
      )}
    >
      <div className="cursor-pointer" onClick={() => props.onEdit(type)}>
        <LabelValue value={`${name}`} icon="home" />
        <LabelValue value={`${address}`} icon="map-marker" />
      </div>
    </CargomaticCard>
  );
};

export default withTranslation()(LocationPreview);
